import { FormGroup } from '@angular/forms';
import { Store } from '@ngrx/store';
import { cloneDeep } from 'lodash-es';
import { updateVerbaleOnStore } from '@core/helpers/create-validator.helper';
import { getControl, getGroup } from '@shared/helpers/form.helper';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { withChangeDebounced } from '@shared/operators/with-change-debounced.operator';
import { MyVerbale } from '../../../models/interfaces/revisione.interface';
import { Revisione53State } from '../../../store/revisione53.reducers';
import { formPaths } from '@shared/constants/form-paths.const';
import { getNatMutControl } from '../validators/helpers/natura-mutualistica-form-validators.helper';

export const setNatMutInseritoVersoSociListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    my_A1versoSociPrimoAnno(form, store);
    setInseritoVersoSociListeners(form, store);
};

const my_A1versoSociPrimoAnno = (form: FormGroup, store: Store<Revisione53State>): void => {
    const schedaPrevalenzaGroup = getGroup(form, `${formPaths.naturaMutualistica}.my_SchedaPrevalenza`);
    const my_A1versoSociPrimoAnnoControl = getControl(schedaPrevalenzaGroup, 'my_A1versoSociPrimoAnno');
    const my_InseritoA1VersoSociControl = getControl(form, 'my_InseritoA1VersoSoci');
    const ckOffreBeniServControl = getNatMutControl(form, 'my_CkOffreBeniServ');

    my_A1versoSociPrimoAnnoControl.valueChanges.pipe(withChangeDebounced(my_A1versoSociPrimoAnnoControl)).subscribe((value) => {
        if (!isNilOrEmpty(value) && ckOffreBeniServControl.value === '0') {
            my_A1versoSociPrimoAnnoControl.patchValue('', { emitEvent: false });
            updateVerbaleOnStore(store, (myVerbale) => {
                const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
                myVerbaleClone.my_SezioneI__Rilevazione.my_NaturaMutualistica.my_SchedaPrevalenza.my_A1versoSociPrimoAnno = '';
                return myVerbaleClone;
            });
            return;
        }

        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            if (value === null) {
                myVerbaleClone.my_InseritoA1VersoSoci = '0';
                my_InseritoA1VersoSociControl.patchValue('0', { emitEvent: false });
            }
            return myVerbaleClone;
        });
    });
};

const setInseritoVersoSociListeners = (form: FormGroup, store: Store<Revisione53State>): void => {
    inseritoVersoSociHelper(form, store, 'my_InseritoA1VersoSoci', 'my_A1versoSoci');
    inseritoVersoSociHelper(form, store, 'my_InseritoB9VersoSoci', 'my_B9versoSoci');
    inseritoVersoSociHelper(form, store, 'my_InseritoB7VersoSoci', 'my_B7ricevSoci');
    inseritoVersoSociHelper(form, store, 'my_InseritoB6VersoSoci', 'my_B6confSoci');
    inseritoVersoSociHelper(form, store, 'my_InseritoB6QtaVersoSoci', 'my_QtaConfSoci');
};

/**
 * Propaga il flag my_Inserito*VersoSoci (1/0) in base alla sola presenza di valore nel campo
 * della scheda prevalenza (fedele a InfoPath: case "my:A1versoSoci" ecc. non condizionano questo
 * flag alla checkbox "prevede di..."). L'incoerenza valore/checkbox è validata, senza cancellare
 * il dato, da schedaPrevalenzaValuesHelper nei rispettivi *.rules.ts.
 */
const inseritoVersoSociHelper = (form: FormGroup, store: Store<Revisione53State>, storeInseritoKey: string, basePath: string): void => {
    const naturaMutualisticaGroup = getGroup(form, 'my_SezioneI__Rilevazione.my_NaturaMutualistica');
    const versoSociControl = getControl(getGroup(naturaMutualisticaGroup, 'my_SchedaPrevalenza'), basePath);
    const my_InseritoVersoSociControl = getControl(form, storeInseritoKey);

    versoSociControl.valueChanges.pipe(withChangeDebounced(versoSociControl)).subscribe(() => {
        const correctValue = isNilOrEmpty(versoSociControl.value) ? '0' : '1';
        my_InseritoVersoSociControl.patchValue(correctValue, { emitEvent: false });
        updateVerbaleOnStore(store, (myVerbale) => {
            const myVerbaleClone: MyVerbale = cloneDeep(myVerbale);
            myVerbaleClone[storeInseritoKey] = correctValue;
            return myVerbaleClone;
        });
    });
};
